// Дашборд — корневой адрес панели. Остальные разделы открываются как /{code}.
export function sectionPath(code) {
  if (!code || code === 'dashboard') return '/';
  return `/${encodeURIComponent(code)}`;
}

export function sectionFromPath(pathname) {
  const segment = String(pathname || '')
    .split('?')[0]
    .split('#')[0]
    .replace(/^\/+|\/+$/g, '')
    .split('/')[0];
  if (!segment) return '';
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}

export function userCardPath(sectionCode, userId) {
  return `${sectionPath(sectionCode)}/${encodeURIComponent(userId)}`;
}

export function userIdFromPath(pathname, sectionCode) {
  const parts = String(pathname || '')
    .split('?')[0]
    .split('#')[0]
    .replace(/^\/+|\/+$/g, '')
    .split('/')
    .filter(Boolean);
  if (parts.length !== 2 || !sectionCode) return '';
  let section = parts[0];
  let userId = parts[1];
  try {
    section = decodeURIComponent(section);
    userId = decodeURIComponent(userId);
  } catch {
    return '';
  }
  if (section !== sectionCode || !userId) return '';
  return userId;
}

export function sectionToOpen(items, requested, fallbackCode) {
  const list = items || [];
  const codes = new Set(list.map((item) => item.code));
  if (requested && codes.has(requested)) return requested;
  if (!requested && fallbackCode && codes.has(fallbackCode)) return fallbackCode;
  if (codes.has('dashboard')) return 'dashboard';
  return list[0] ? list[0].code : '';
}

function pathParts(pathname) {
  return String(pathname || '')
    .split('?')[0]
    .split('#')[0]
    .replace(/^\/+|\/+$/g, '')
    .split('/')
    .filter(Boolean)
    .map((part) => {
      try {
        return decodeURIComponent(part);
      } catch {
        return part;
      }
    });
}

export function managersSectionOf(items) {
  return (items || []).find((item) => item.code === 'managers' || item.title === 'Менеджеры');
}

export function parseManagersLocation(pathname, sectionCode) {
  if (!sectionCode) return { view: 'employees' };
  const parts = pathParts(pathname);
  if (parts[0] !== sectionCode) return { view: 'employees' };
  const rest = parts.slice(1);
  if (!rest.length) return { view: 'employees' };
  if (rest[0] === 'divisions') {
    if (rest[1] === 'new') return { view: 'divisions', create: true };
    if (rest[1]) return { view: 'divisions', divisionId: rest[1] };
    return { view: 'divisions' };
  }
  return { view: 'card', managerId: rest[0], tab: rest[1] || '' };
}

export function managersPath(sectionCode, location = {}) {
  const root = sectionPath(sectionCode);
  if (location.view === 'divisions') {
    if (location.create) return `${root}/divisions/new`;
    if (location.divisionId) return `${root}/divisions/${encodeURIComponent(location.divisionId)}`;
    return `${root}/divisions`;
  }
  if (location.view === 'card' && location.managerId) {
    const card = `${root}/${encodeURIComponent(location.managerId)}`;
    return location.tab ? `${card}/${encodeURIComponent(location.tab)}` : card;
  }
  return root;
}

export function managersLocationKeepsAddress(location) {
  return Boolean(
    location
    && (location.view === 'divisions'
      || location.view === 'card'
      || location.create
      || location.divisionId
      || location.managerId),
  );
}
